import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/mdf/requests/:id/mark-spent
//
// Replaces /app/admin/mdf/_actions.ts::markRequestSpentAction. Pessimistic.
// Service-side fan-out: posts a HubSpot Note (fire-and-forget). Unlike
// approve/decline, mark-spent does NOT dispatch a notification event
// (matches legacy parity — partners learn via the partner-side status
// chip, not a separate notification).
type Vars = { id: string; fundId: string };

export function useMarkRequestSpent() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, Vars>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/mdf/requests/${id}/mark-spent`, {
        method: "POST",
      }),
    onSuccess: (_data, { id, fundId }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.request(id) });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(fundId) });
      toast.success("Marked as spent");
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to mark as spent");
    },
  });
}
